<script>
import Menu from 'ant-design-vue/es/menu';

export default {
  name: 'MSubMenu',
  extends: Menu.SubMenu
};
</script>
